module.exports = __webpack_public_path__ + "static/beds4u-logo-d0565dda61677c7bd52ed8e8d342c0ec.png";